import MarkerModel from "../model/MarkerModel";
import BaseCollection from "../../../app/library/marionette/collection/BaseCollection";

const MarkerCollection = BaseCollection.extend({

    model: MarkerModel

});

export default MarkerCollection;